<template>
  <div class="dashboard">
    <div v-if="pageCat == 'goldlocker'" class="goldlocker content">
      <div class="dashboard-main-content">
        <div class="sidebar-toggle" @click="toggleSidebar"></div>
        <GoldlockerContent
          v-if="currentPage.endsWith('dashboard/goldlocker')"
        />
        <CashIn v-if="currentPage.endsWith('dashboard/cash-in')" />
        <RechargeContent v-if="currentPage.endsWith('dashboard/recharge')" />
        <LinkStripeContent
          v-if="currentPage.endsWith('dashboard/link-stripe')"
        />
        <TransactionDetails v-if="currentPage.endsWith('-details')" />
        <ConverGCoins v-if="currentPage.endsWith('-convert')" />
        <AllTransactions
          v-if="currentPage.endsWith('dashboard/transactions')"
        />
        <WithdrawFunds v-if="currentPage.endsWith('dashboard/withdraw')" />
        <GCoinsDeposit
          v-if="currentPage.endsWith('dashboard/security-deposit')"
        />
        <UpgradeGS v-if="currentPage.endsWith('dashboard/upgrade')" />
      </div>
      <div class="my-account-sidebar" :class="showSidebar ? 'show' : ''">
        <div class="btn-close" @click="showSidebar = false"></div>
        <MyAccount />
      </div>
    </div>
    <div class="my-nft content" v-if="pageCat == 'nft'">
      <div class="nft-sidebar">
        <div class="items">
          <span class="title">
            {{ $t("dashboard.nft.mynft") }}
          </span>
          <div class="listing">
            <img src="../assets/icon-nft-small.png" alt="NFT" />
            <span>
              {{ $t("dashboard.nft.mylisting") }}
            </span>
          </div>
        </div>
      </div>
      <div class="nft-main-content">
        <NFTListing v-if="currentPage.endsWith('dashboard/nft')" />
      </div>
    </div>
  </div>
</template>

<script>
import MyAccount from "@/components/MyAccount.vue";
import GoldlockerContent from "./dashboard/GoldlockerContent.vue";
import RechargeContent from "./dashboard/RechargeContent.vue";
import LinkStripeContent from "./dashboard/LinkStripeContent.vue";
import TransactionDetails from "./dashboard/TransactionDetails.vue";
import AllTransactions from "./dashboard/AllTransactions.vue";
import WithdrawFunds from "./dashboard/WithdrawFunds.vue";
import GCoinsDeposit from "./dashboard/GCoinsDeposit.vue";
import UpgradeGS from "./dashboard/UpgradeGS.vue";
import ConverGCoins from "./dashboard/ConverGCoins.vue";
import CashIn from "./dashboard/CashIn.vue";
import NFTListing from "./dashboard/NFTListing.vue";

export default {
  components: {
    GoldlockerContent,
    MyAccount,
    CashIn,
    RechargeContent,
    LinkStripeContent,
    TransactionDetails,
    ConverGCoins,
    AllTransactions,
    WithdrawFunds,
    GCoinsDeposit,
    UpgradeGS,
    NFTListing
  },
  data() {
    return {
      currentPage: "",
      pageCat: "goldlocker",
      showSidebar: false,
    };
  },
  mounted() {
    this.getCurrentPage();
  },
  methods: {
    getCurrentPage() {
      const currentPath = this.$router.history.current.path.substring(1);
      console.log("getCurrentPage: ", currentPath);
      this.currentPage = currentPath;
      if (currentPath == "dashboard") this.currentPage = "dashboard/goldlocker";
      if (currentPath.includes("nft")) {
        this.pageCat = "nft";
      } else {
        this.pageCat = "goldlocker";
      }
      console.log("pageCat: ", this.pageCat);
    },
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
  },
  watch: {
    $route(to) {
      const currentPath = this.$router.history.current.path.substring(1);
      this.currentPage = currentPath;
      if (currentPath == "dashboard" && to.params.page == undefined)
        this.currentPage = "dashboard/goldlocker";
      if (currentPath.includes("nft")) {
        this.pageCat = "nft";
      } else {
        this.pageCat = "goldlocker";
      }
      this.showSidebar = false;
      window.scrollTo(0, 0);
    },
    "$i18n.locale": function () {
      this.getCurrentPage();
    },
  },
};
</script>

<style>
.dashboard {
  width: 100%;
  margin: 90px auto 1.5rem;
  padding: 0;
  display: flex;
  justify-content: center;
  .goldlocker {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 1rem;
    .dashboard-main-content {
      position: relative;
      background-color: white;
      padding: 1rem;
      box-sizing: border-box;
      border-radius: 1rem;
      width: 100%;
      hr {
        display: block;
      }
      .sidebar-toggle {
        position: absolute;
        top: 1rem;
        right: 1rem;
      }
      .sidebar-toggle::after {
        content: "\2807";
        font-size: 1.5rem;
      }
    }
    .my-account-sidebar {
      display: none;
      padding: 1rem;
      box-sizing: border-box;
      border-radius: 1rem;
    }
    .my-account-sidebar.show {
      display: block;
      position: fixed;
      top: 0;
      left: -100px;
      background-color: white;
      width: 100%;
      max-width: 292px;
      box-shadow: 0 0.5rem 0.5rem rgba(0, 0, 0, 0.3);
      height: 100%;
      z-index: 999;
      border-radius: 0;
      -webkit-animation: slide 0.5s forwards;
      animation: slide 0.5s forwards;
      .btn-close {
        border: 3px solid black;
        background-color: transparent;
        font-weight: 800;
        font-size: 20px;
        line-height: 20px;
        vertical-align: middle;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0 3px 6px;
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
      }
    }
  }
  .my-nft {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 1rem;
    .nft-main-content {
      position: relative;
      background-color: white;
      padding: 1rem;
      box-sizing: border-box;
      border-radius: 1rem;
      width: 100%;
      hr {
        display: block;
      }
      .sidebar-toggle {
        position: absolute;
        top: 1rem;
        right: 1rem;
      }
      .sidebar-toggle::after {
        content: "\2807";
        font-size: 1.5rem;
      }
    }
    .nft-sidebar {
      display: none;
    }
  }
}
@-webkit-keyframes slide {
  100% {
    left: 0;
  }
}

@keyframes slide {
  100% {
    left: 0;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .dashboard {
    .goldlocker {
      gap: 1rem;
      .dashboard-main-content {
        width: 75%;
        .sidebar-toggle {
          display: none;
        }
      }
      .my-account-sidebar,
      .my-account-sidebar.show {
        display: flex;
        width: 25%;
        background-color: white;
        position: unset;
        height: auto;
        box-shadow: none;
        border-radius: 1rem;
        .btn-close {
          display: none;
        }
      }
    }
    .my-nft {
      gap: 1rem;
      .dashboard-main-content {
        width: 80%;
        .sidebar-toggle {
          display: none;
        }
      }
      .nft-sidebar {
        padding: 1rem;
        box-sizing: border-box;
        display: flex;
        width: 20%;
        background-color: white;
        position: unset;
        height: auto;
        box-shadow: none;
        border-radius: 1rem;

        .items {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          gap: 0.5rem;
          .title {
            color: #13c8ff;
            font-size: 1.25rem;
            font-weight: 600;
          }
          .listing {
            color: #a0afbe;
            font-size: 1.1rem;
            display: inline;
            span {
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
}
/* X-Large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .dashboard {
    margin: 1.5rem auto;
    .goldlocker {
      padding: 0;
    }
    .my-nft {
      padding: 0;
    }
  }
}
</style>
